<template>
    <div id="home_page_map"></div> 
</template>
<script>
    import http from '@/api/cardData'
    import Bus from '@/utils/Bus.js'
    import echarts from 'echarts';
    import geoData from '../map-data/get-geography-value.js';
    export default {
        name: 'homeMap',
        data(){
             return{
                 text:'全国',
                 menu:{
                     all:[{
                            start:0,
                            end:10000000,
                        },{
                            start:10000000,
                            end:20000000
                        },{
                            start:20000000,
                            end:30000000
                        },{
                            start:30000000,
                            end:40000000
                        },{
                            start:40000000,
                            label:'40000000以上'
                        }],
                        one:[{
                            start:0,
                            end:100000,
                        },{
                            start:100000,
                            end:500000
                        },{
                            start:500000,
                            end:1000000
                        },{
                            start:1000000,
                            end:5000000
                        },{
                            start:5000000,
                            label:'5000000以上'
                        }]
                 }
             }
        },
        props: {
            cityData: [Array,Object],
            time:Array,
            title:Number,
        },
        watch:{
            '$store.state.app.tab':function(value,oldValue){
                this.initData();
            },'cityData':function(){
                this.initData();
            },'cityData.nameName':function(){
                this.initData();
            },
        },
        created() {
            //this.initData()
        },
        computed: {
            'allTab':function(){
                return this.$store.state.app.tab
            },
            'titleArr':function(){
                return this.$store.state.app.titleArr
            },

            
        },
        mounted() {
            var convertData = function(data) {
                let res = [];
                let len = data.length;
                for (var i = 0; i < len; i++) {
                    var geoCoord = geoData[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            };
            this.initData();
        },
        methods: {
            initData() {
                this.initCanvas();
            },
            initNum(num) {
                num = num + '';
                if(num.indexOf('.') == -1){
                    return  num
                }
                return num.split('.')[0]
            },
            initCanvas(e) {
                //e为true代表是切换时间
                let that = this;
                let mapData={
                    title: {
                        text: '',
                        subtext: ''
                    },
                    dataRange: {
                        x: 'left',
                        y: '80px',
                        splitList:this.cityData.nameName?this.menu.one:this.menu.all,
                        color: ['#0b65bc', '#3289dc', '#5faef8', '#94cbff'],
                    },
                    tooltip: {
                        // backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        borderWidth: 1,
                        // borderColor: '#ccc',
                        padding: 10,
                        textStyle: {
                            color: '#ffffff'
                        },
                        extraCssText: 'width: 150px'
                    },
                    toolbox: {
                        show: false,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: {
                                show: false
                            },
                            dataView: {
                                show: false,
                                readOnly: false
                            }
                        }
                    },
                    series: [{
                        name: '',
                        type: 'map',
                        mapType: 'china',
                        mapLocation: {
                            x: 'left'
                        },
                        zoom: 1.2,
                        // selectedMode: 'multiple',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
    
                                },
                                areaColor: '#e7e7e7',
                                borderColor: '#ffffff'
                            },
                            emphasis: {
                                areaColor: '#00dcbb',
                                label: {
                                    show: false
                                }
                            }
                        },
                        data:[]
                    }],
                    animation: false
                }
                mapData.series[0].data=this.cityData.length?this.cityData:this.cityData.item;
                mapData.title.text=this.cityData.nameName?this.cityData.nameName+'货运平台车辆途经各省次数分布-2018年':this.text+'货运平台车辆途经各省次数分布-2018年';
                var map = echarts.init(document.getElementById('home_page_map'));
                const chinaJson = require('../map-data/china.json');
                echarts.registerMap('china', chinaJson);
                map.setOption(mapData);
                window.addEventListener('resize', function() {
                    map.resize();
                });
            },
        }
    };
</script>
<style scoped>
#home_page_map{
    width:calc(100% - 10px);
    height:100%;
}
/* .big{
    position: relative;
    height:100%;
}
span{
    position: absolute;
    top:200px;
    height:200px;
    z-index: 10;
} */
</style>

